import axios from 'axios'

let logoutHandler = null

export function setLogoutHandler(fn) {
  logoutHandler = fn
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_KEY || '/api/v1/app',
})

axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

axiosInstance.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token')
      logoutHandler?.()
    }
    return Promise.reject(err)
  },
)

export default axiosInstance
